import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWallSketch = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "32px",
	height: "32px",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "layer1",
		children: [
			/* @__PURE__ */ _jsx("line", {
				x1: 8.5,
				y1: 10,
				x2: 13.2,
				y2: 13.4,
				style: {
					stroke: "currentColor",
					strokeWidth: 2,
					strokeLinecap: "butt"
				}
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 23.5,
				y1: 10,
				x2: 18.8,
				y2: 13.4,
				style: {
					stroke: "currentColor",
					strokeWidth: 2,
					strokeLinecap: "butt"
				}
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 13.7,
				y1: 18.8,
				x2: 10.2,
				y2: 23.8,
				style: {
					stroke: "currentColor",
					strokeWidth: 2,
					strokeLinecap: "butt"
				}
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 18.3,
				y1: 18.8,
				x2: 21.8,
				y2: 23.8,
				style: {
					stroke: "currentColor",
					strokeWidth: 2,
					strokeLinecap: "butt"
				}
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 6,
				cy: 8,
				r: 3.5,
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 2
				}
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 26,
				cy: 8,
				r: 3.5,
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 2
				}
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 16,
				cy: 16,
				r: 4,
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 2
				}
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 8,
				cy: 26,
				r: 3.5,
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 2
				}
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 24,
				cy: 26,
				r: 3.5,
				style: {
					fill: "none",
					stroke: "currentColor",
					strokeWidth: 2
				}
			})
		]
	})
});
export default SvgWallSketch;
